import localforage from 'localforage';

const STORE_NAME = 'trading-view-layouts';
const STORE_CONFIG = {
  name: STORE_NAME,
  storeName: 'layouts',
};

const storage = localforage.createInstance(STORE_CONFIG);

const ensureReady = async () => {
  try {
    await storage.ready();
  } catch (error) {
    console.error('[TradingViewLayoutStorage] IndexedDB not ready', error);
    throw error;
  }
};

const buildKey = (key: string) => `tv-layout:${key}`;

export const tradingViewLayoutStorage = {
  async load(key: string): Promise<object | null> {
    try {
      await ensureReady();
      return (await storage.getItem<object>(buildKey(key))) ?? null;
    } catch (error) {
      console.error('[TradingViewLayoutStorage] Failed to load layout', { key, error });
      return null;
    }
  },
  async save(key: string, layout: object): Promise<void> {
    try {
      await ensureReady();
      await storage.setItem(buildKey(key), layout);
    } catch (error) {
      console.error('[TradingViewLayoutStorage] Failed to save layout', { key, error });
    }
  },
  async remove(key: string): Promise<void> {
    try {
      await ensureReady();
      await storage.removeItem(buildKey(key));
    } catch (error) {
      console.error('[TradingViewLayoutStorage] Failed to remove layout', { key, error });
    }
  },
};

export const makeLayoutStorageKey = (containerId: string, suffix?: string) =>
  suffix ? `${containerId}:${suffix}` : containerId;
